import React from 'react'

const TextBookSubtopicMaster = () => {
  return (
    <div>TextBookSubtopicMaster</div>
  )
}

export default TextBookSubtopicMaster